module.exports = __webpack_public_path__ + "img/egg.22990cb0.png";